import React from "react";

import {
  emitProductListInteraction,
  ProductListInteractionType,
} from "@catchoftheday/analytics";
/** TODO (RU): Circular dep: import from elsewhere */
import {
  convertProductCard,
  ProductCard,
  ProductCardProps,
  ProductCardType,
} from "@catchoftheday/product-components";

import { InteractionTrackingData } from "../../types";

type RecommendedProduct = ProductCardType & {
  sourceType?: number;
};

type GetProductTilesProps = InteractionTrackingData & {
  products: RecommendedProduct[];
  /** Custom render function to allow for variations of ProductCard */
  render?: (propsArray: ProductCardProps[]) => React.ReactNode[];
};

export const getProductTiles = ({
  products,
  sourceId,
  sourceType: recommenderSourceType,
  fromProduct,
  render,
}: GetProductTilesProps): React.ReactNode[] => {
  const productItems = products.map((product, index) => ({
    ...convertProductCard(product, product.bestOffer),
    sourceType: product.sourceType || recommenderSourceType,
    sourceId,
    sourcePosition: index + 1,
  }));
  type ProductItem = (typeof productItems)[0];

  const handleProductClick = ({
    interaction,
    product,
    position,
  }: {
    interaction: ProductListInteractionType | undefined;
    product: ProductItem;
    position: number;
  }) => {
    emitProductListInteraction({
      interaction,
      product_id: Number(product.id),
      offer_id: Number(product.offerId),
      source_position: position,
      source_type: product.sourceType,
      source_id: sourceId || null,
      ...fromProduct,
    });
  };

  const productProps = (
    productItem: ProductItem,
    index: number
  ): ProductCardProps => {
    return {
      productItem,
      onProductClick: () =>
        handleProductClick({
          interaction: "click",
          product: productItem,
          position: index + 1,
        }),
      onAddToCart: () =>
        handleProductClick({
          interaction: "addToCart",
          product: productItem,
          position: index + 1,
        }),
    };
  };

  if (render) {
    return render(
      productItems.map((productItem, index) => productProps(productItem, index))
    );
  }

  return productItems.map((productItem, index) => {
    return (
      <ProductCard key={productItem.id} {...productProps(productItem, index)} />
    );
  });
};
